module.exports = __webpack_public_path__ + "img/rein_deer.c073cc5a.jpg";